import React from 'react'
import { PulseLoader } from 'react-spinners'
import './Loading.scss'

const Loading = ({ isLoading, text = 'Loading...', children }) => {
  if (isLoading) {
    return (
      <div className="loading" data-testid="loading-component">
        <div>
          <div className="pulse">
            <PulseLoader loading />
          </div>
          <p>{text}</p>
        </div>
      </div>
    )
  }

  return typeof children === 'function' ? children() : children
}

export default Loading
